<div class="form-field">
  <span class="form-field-label">
    {{ label }}
  </span>
  <div class="inner" [class.delete]="disabled">
    <app-datepicker
      [disabled]="disabled"
      [form]="date"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (formChange)="onChange()"
      class="inner-item"
    ></app-datepicker>
    <app-timepicker
      [disabled]="disabled"
      [form]="time"
      (formChange)="onChange()"
      class="inner-item"
    ></app-timepicker>
  </div>
  <ng-content></ng-content>
</div>
